export default __webpack_public_path__ + "static/media/siteMap1.b655f0c5.jpg";